import React, { FC } from "react";

import { TableBodyProps } from "./types";
import { getKey, useColumnsConfig } from "../../utils";
import Row from "../Row";

export const TableBody: FC<TableBodyProps> = ({
  columns: columnsConfig,
  data = [],
  renderExpandedRow,
  onDoubleClick,
  children,
}) => {
  const columns = useColumnsConfig(columnsConfig);

  return (
    <tbody className="ams-table__body">
      <>
        {data.map((rowData, rowIndex) => {
          return (
            <Row
              key={getKey("tr", rowIndex)}
              data={rowData}
              columns={columns}
              renderExpandedRow={renderExpandedRow}
              onDoubleClick={onDoubleClick}
            />
          );
        })}
        {children}
      </>
    </tbody>
  );
};
